import api from './api';

const BASE = '/finanzas';

export const finanzasService = {
    listarDepreciacion: async (filtros = {}) => {
        const response = await api.get(`${BASE}/depreciacion`, { params: filtros });
        return response.data;
    },

    obtenerDepreciacion: async (activoId) => {
        const response = await api.get(`${BASE}/depreciacion/${activoId}`);
        return response.data;
    },

    resumen: async () => {
        const response = await api.get(`${BASE}/resumen`);
        return response.data;
    },

    // Sin activoIds: estima el siguiente lote de activos sin precio (máx. 15).
    estimarPrecioMercado: async (activoIds = null) => {
        const response = await api.post(`${BASE}/precio-mercado-ia`, activoIds ? { activo_ids: activoIds } : {});
        return response.data;
    },

    importarNetsuite: async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post(`${BASE}/importar-netsuite`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },
};
